import * as React from 'react';
import ApplicationWaitingForReview, { Props } from './application_waiting_for_review';
import { shallow, ShallowWrapper } from 'enzyme';
import applicationDummy from '__fixtures__/application_dummy';

const createTestProps = moreProps => {
  return {
    moveToReviewing: jest.fn(),
    rejectApplication: jest.fn(),
    application: applicationDummy,
    ...moreProps,
  };
};

let props: Props;
let wrapped: ShallowWrapper;

describe('Application Waiting For Review component', () => {
  beforeEach(() => {
    props = createTestProps({});
    wrapped = shallow(<ApplicationWaitingForReview {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
